var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 73.46 63.17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a60b4c8b-417d-482e-8292-d123f55fa487",
    x1: 2,
    y1: 34.58,
    x2: 73.46,
    y2: 34.58,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00f282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00ba8f"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "no") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ba6ae2a2-0e54-4a3f-8bb9-32e1e8dcc983",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a1b9710a-99f0-4d39-bad6-066493a59835",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "23.36 49.03 9.07 34.74 2 41.81 23.36 63.17 73.46 13.07 66.39 6 23.36 49.03",
    fill: "url(#a60b4c8b-417d-482e-8292-d123f55fa487)"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "21.36 43.03 7.07 28.74 0 35.81 21.36 57.17 71.46 7.07 64.39 0 21.36 43.03",
    fill: "#22364c"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNo);
export default __webpack_public_path__ + "static/media/no.a4c9eaacc463752370d2acb951ebb10d.svg";
export { ForwardRef as ReactComponent };